import axios from 'axios';

export default class AxiosHelperMyCampus {

    static getUrl(baseUrl, queryData) {
        var url = '/' + window.HSLU.scLanguage + baseUrl;
        var query = AxiosHelperMyCampus.getQuery(queryData);
        return url + query;
    }

    static getQuery(queryData) {
        if (!queryData) {
            return '';
        }
        const esc = encodeURIComponent;
        const query = Object.keys(queryData).map(k => queryData[k] !== null ? esc(k) + '=' + esc(queryData[k]) : esc(k) + '=').join('&');
        return '?' + query;
    }

    static get(baseUrl, queryData) {
        var url = AxiosHelperMyCampus.getUrl(baseUrl, queryData);
        return axios.get(url);
    }

    static post(baseUrl, bodyData) {
        var url = AxiosHelperMyCampus.getUrl(baseUrl, null);
        return axios.post(url, bodyData);
    }
}
